/** @module csi/view/customview/_CustomViewAction */
define([
	"dojo/_base/declare",
	"csi/def/Action",
	"csi/prefs"
], function(declare,Action,csiPrefs) {

	return declare(Action, {
		/** @property {boolean} customViewAccess - set to true if user must have admin access to the view, either as a Custom View Administrator, or the user for a personal view */
		//customViewAccess: false,

		/** @property {boolean} customViewInstance - set to true if the action cannot be performed on the system Default view */
		//customViewInstance: false,

		/** @property {boolean} customViewDirty - set to true or false if the action can only be performed when the custom view dirty status matches the given value */
		//customViewDirty: false,

		/**
		 * @override
		 * Add additional access checks to action based on configured properties
		 */
		hasAccess: function(ctx) {
			var	cv = ctx.view.getSelectedCustomView();

			if (!cv) {
				// it's possible that the selected custom view is null while deleting a custom view
				return false;
			}
			
			if (this.customViewAccess) {
				if (cv.isSystemWide() && !csiPrefs.hasAdminAccess()) {
					return false;
				}

				if (cv.isSharedWithRoles() && !csiPrefs.hasEditAccess()) {
					return false;
				}

				if (!cv.isShared() && !cv.isCurrentUser()) {
					return false;
				}
			}

			if ((this.customViewDirty != null) && (this.customViewDirty != ctx.view.get("customViewDirty"))) {
				return false;
			}

			if (this.customViewInstance && cv.isDefaultView()) {
				return false;
			}

			return this.inherited(arguments);
		}
	});
});